var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"48f66baff257a8f2f75e98bed6c1d5d3a048fd4c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["flow-club@flow-club"]={id:"48f66baff257a8f2f75e98bed6c1d5d3a048fd4c"};
      